import axios from 'axios';
import { testLocalhost } from '../constants/defaultValues';

let HEADER = {
  'Content-Type': 'application/json',
};

const Provider = async (
  options = { type: '', url: '', data: null, token: false }
) => {
  const { type, url, data, token } = options;

  // ใช้ environment detection ที่ดีกว่า
  const isLocal = testLocalhost ||
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1';

  const BASE_URL = isLocal
    ? 'http://localhost:5000/api-thannicalspa-2021/asia-southeast2'
    : 'https://asia-southeast2-api-thannicalspa-2021.cloudfunctions.net';

  // console.log(`[API] Environment: ${isLocal ? 'LOCAL' : 'PRODUCTION'}`);
  // console.log(`[API] Base URL: ${BASE_URL}`);
  // console.log(`[API] Request: ${type} ${url}`);

  if (token) {
    HEADER = {
      ...HEADER,
      'x-has-accesstoken': token,
    };
  }

  const instanceMain = axios.create({
    baseURL: BASE_URL,
    headers: HEADER,
    withCredentials: true,
    // timeout: 30000, // 30 seconds timeout
    transformResponse: [
      function apiData(data1) {
        try {
          const data2 = JSON.parse(data1);
          if (data2 === null) return data2;
          if (data2?.msg === 'Authen Data Error') {
            window.location = `${BASE_URL}/403`;
          }
          return data2;
        } catch (error) {
          console.error('API Parse Error:', error);
          console.error('Response data:', data1);
          throw error;
        }
      },
    ],
  });

  let dataRes;
  try {
    switch (type) {
      case 'GET':
      case 'SHOW':
        dataRes = await instanceMain.get(url);
        break;
      case 'POST':
        dataRes = await instanceMain.post(url, data);
        break;
      case 'PUT':
        dataRes = await instanceMain.put(url, data);
        break;
      case 'DELETE':
        dataRes = await instanceMain.delete(url);
        break;
      default:
        throw new Error(`Invalid type: ${type}`);
    }
    // console.log(`[API] Success:`, dataRes.data);
    return dataRes.data;
  } catch (error) {
    console.error('[API] Error:', error.message);
    if (error.response) {
      console.error('[API] Response Error:', error.response.data);
      console.error('[API] Status:', error.response.status);
    }
    throw error;
  }
};

export default Provider;